import { Alert } from '@mui/material';
import type { DmpFeatureFailure } from '@/utils/dmpFeatureFailure';

export default function FeatureFailure({ failure, english }: { failure: DmpFeatureFailure | null; english: boolean }) {
  if (!failure) return null;
  return <Alert severity="error" sx={{ my: 2, overflowWrap: 'anywhere', fontSize: 'inherit' }}>
    {failure.message}
    {failure.kind === 'quota' && <div><a href="/profile/subscriptionDetail" style={{ display: 'inline-flex', alignItems: 'center', minHeight: 44, textDecoration: 'underline' }}>
      {english ? 'View allowance, add-ons and plans' : '查看額度、加購與方案'}
    </a></div>}
  </Alert>;
}
